import {Injectable} from '@angular/core';

import {UserService} from 'app/service/user/user.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class UserGuard {
    constructor(private userService: UserService) {}

    canActivate(): Observable<boolean> {
        return this.userService.fetchUser().pipe(map(user => !!user));
    }
}
